import { useUploadManager } from 'hooks/useUploadManager'

export function UploadManager() {
  useUploadManager()
  return null // This component doesn't render anything
}
